<template>
  <v-speed-dial
    v-model="showItens"
    direction="bottom"
    transition="slide-y-transition"
    v-bind="$attrs">

    <template v-slot:activator>
      <v-btn v-model="showItens" fab text small title="Exibir">
        <v-icon v-if="showItens">
          mdi-close
        </v-icon>
        <v-icon v-else>
          {{ viewModeIcon }}
        </v-icon>
      </v-btn>
    </template>

    <v-btn
      v-for="mode in viewModes"
      :key="mode.id"
      fab dark small
      :title="mode.text"
      :color="viewMode === mode.id ? 'primary' : null"
      @click="viewMode = mode.id">
      <v-icon>{{ viewModeIconFor(mode.id) }}</v-icon>
    </v-btn>
  </v-speed-dial>
  
</template>

<script>
import Vue from "vue"
export default Vue.component("tj-view-mode-selector", {
  props: {
    value: String,
    itens: Array,
  },

  model: {
    prop:"value",
    event: "update"
  },

  data(){
    return {
      showItens: false
    }
  },

  computed: {
    viewModes(){
      return this.itens || [{id:"none"}]
    },

    viewMode: {
      get(){
        return this.value
      },
      set(v){
        const value = (this.viewModes.find(item => item.id === v) || this.viewModes[0]).id
        if(value != this.value) this.$emit("update", value)
      }
    },

    viewModeIcon() {
      return this.getViewModeIcon(this.viewMode);
    },

    viewModeIconFor() {
      return v => this.getViewModeIcon(v);
    },


  },

  methods: {
    getViewModeIcon(v) {
      switch (v) {
        case "card":  return "mdi-card-text-outline";
        case "full": return "mdi-file-document-outline";
        case "table": return "mdi-format-list-bulleted";
        default:
          return "mdi-help-rhombus";
      }
    }

  }
})
</script>